import openApiHttp from "@/utils/request2"
export let getCode = () => {
    return openApiHttp({
        url: "/user/userInfo"
    }, false)
}
export let addFeedBack = (content) => {
    return openApiHttp({
        url: "/user/addFeedBack",
        method: "post",
        data: {
            content,
        },
    }, true)
}
export let updateimg = (file) => {
    return openApiHttp({
        url: "/file/picUpload",
        method: "post",
        headers: { 'content-type': 'multipart/form-data' },
        data: {
            file,
        }
    }, true)
}
export let updateUserInfo = (data) => {
    return openApiHttp({
        url: "/user/updateUserInfo",
        headers: { 'Content-Type': 'application/json' },
        method: "post",
        data,
    }, true)
}
export let dianzan = (data) => {
    return openApiHttp({
        url: "/like",
        method: "post",
        data,
    }, true)
}
export let getzan = (data) => {
    return openApiHttp({
        url: `/like/getLikeCount?likeType=${data.likeType}&targetId=${data.targetId}&likedUserId=${data.likedUserId}`,
        method: "post",
    }, false)
}
export let getconsumption = (params) => {
    return openApiHttp({
        url: "/user/userBuyRecord",
        method: "get",
        params,
    }, true)
}
export let getpurchase = (params) => {
    return openApiHttp({
        url: "/user/BookOrderPay",
        method: "get",
        params,
    }, true)
}
export let getuserinfo = (params) => {
    return openApiHttp({
        url: "/book/queryList",
        method: "get",
        params,
    }, true)
}
export let uuidtoken = (uuid) => {
    return openApiHttp({
        url: "/user/visitorRegister?userName=" + uuid,
        method: "post",
    }, false)
}